import { useRouteMatch } from "react-router-dom";

import { standardCheckoutRoutes, trialCheckoutRoutes } from "@jti/fe-common";

type UseFailedPaymentFlowType = {
  isFailedPaymentFlow: boolean;
};

export const useFailedPaymentFlow = (): UseFailedPaymentFlowType => {
  const isStandardCheckoutFailedPaymentFlow = !!useRouteMatch(standardCheckoutRoutes.payment.failedPaymentPath);
  const isFailedPaymentFlowTrial = !!useRouteMatch(trialCheckoutRoutes.payment.failedPaymentPath);

  const isFailedPaymentFlow = isStandardCheckoutFailedPaymentFlow || isFailedPaymentFlowTrial;

  return { isFailedPaymentFlow };
};
